import {ModalState} from './interfaces'

export const getInitialState = (): ModalState => ({
    case: null,
})
